import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUTH_GET_FAILURE: "AUTH_GET_FAILURE",
    AUTH_GET_REQUEST: "AUTH_GET_REQUEST",
    AUTH_GET_SUCCESS: "AUTH_GET_SUCCESS",

    AUTH_SET_PASSWORD_PATCH_FAILURE: "AUTH_SET_PASSWORD_PATCH_FAILURE",
    AUTH_SET_PASSWORD_PATCH_REQUEST: "AUTH_SET_PASSWORD_PATCH_REQUEST",
    AUTH_SET_PASSWORD_PATCH_SUCCESS: "AUTH_SET_PASSWORD_PATCH_SUCCESS",

    AUTH_LOGOUT: "AUTH_LOGOUT"
};

export const actionCreators = {
    getRequest: ({ username, idToken }) => ({
        type: actionTypes.AUTH_GET_REQUEST,
        payload: { username, idToken },
        [WAIT_FOR_ACTION]: actionTypes.AUTH_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUTH_GET_FAILURE
    }),
    getSuccess: (auth: any) => ({
        type: actionTypes.AUTH_GET_SUCCESS,
        payload: { ...auth }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.AUTH_GET_FAILURE,
        error
    }),

    setPasswordPatchRequest: (identityId: string, password: string) => ({
        type: actionTypes.AUTH_SET_PASSWORD_PATCH_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUTH_SET_PASSWORD_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUTH_SET_PASSWORD_PATCH_FAILURE,
        payload: { identityId, password }
    }),
    setPasswordPatchSuccess: () => ({
        type: actionTypes.AUTH_SET_PASSWORD_PATCH_SUCCESS
    }),
    setPasswordPatchFailure: (error: Error) => ({
        type: actionTypes.AUTH_SET_PASSWORD_PATCH_FAILURE,
        error
    }),

    logout: () => ({
        type: actionTypes.AUTH_LOGOUT
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
